/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AboutInputs */

const id_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang`)
};

const ms_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perihal`)
};

const da_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om`)
};

const de_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über`)
};

const en_us2_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const es_es2_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const es_mx2_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const fil_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkol Sa`)
};

const fr_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const it_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni`)
};

const hu_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Névjegy`)
};

const nl_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over`)
};

const no_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om`)
};

const pl_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nas`)
};

const pt_br2_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const pt_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const ro_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despre`)
};

const fi_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa`)
};

const sv_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om`)
};

const vi_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giới thiệu`)
};

const tr_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkında`)
};

const cs_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nás`)
};

const bg_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Относно`)
};

const ru_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О проекте`)
};

const uk_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про нас`)
};

const ar_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حول`)
};

const hi_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारे बारे में`)
};

const th_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกี่ยวกับ`)
};

const ja_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

const zh_cn2_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于`)
};

const zh_hant1_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關於`)
};

const ko_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소개`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Nav_AboutInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_about = /** @type {((inputs?: Nav_AboutInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AboutInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_about(inputs)
	if (locale === "ms") return ms_nav_about(inputs)
	if (locale === "da") return da_nav_about(inputs)
	if (locale === "de") return de_nav_about(inputs)
	if (locale === "en-US") return en_us2_nav_about(inputs)
	if (locale === "es-ES") return es_es2_nav_about(inputs)
	if (locale === "es-MX") return es_mx2_nav_about(inputs)
	if (locale === "fil") return fil_nav_about(inputs)
	if (locale === "fr") return fr_nav_about(inputs)
	if (locale === "it") return it_nav_about(inputs)
	if (locale === "hu") return hu_nav_about(inputs)
	if (locale === "nl") return nl_nav_about(inputs)
	if (locale === "no") return no_nav_about(inputs)
	if (locale === "pl") return pl_nav_about(inputs)
	if (locale === "pt-BR") return pt_br2_nav_about(inputs)
	if (locale === "pt") return pt_nav_about(inputs)
	if (locale === "ro") return ro_nav_about(inputs)
	if (locale === "fi") return fi_nav_about(inputs)
	if (locale === "sv") return sv_nav_about(inputs)
	if (locale === "vi") return vi_nav_about(inputs)
	if (locale === "tr") return tr_nav_about(inputs)
	if (locale === "cs") return cs_nav_about(inputs)
	if (locale === "bg") return bg_nav_about(inputs)
	if (locale === "ru") return ru_nav_about(inputs)
	if (locale === "uk") return uk_nav_about(inputs)
	if (locale === "ar") return ar_nav_about(inputs)
	if (locale === "hi") return hi_nav_about(inputs)
	if (locale === "th") return th_nav_about(inputs)
	if (locale === "ja") return ja_nav_about(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_about(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_about(inputs)
	return ko_nav_about(inputs)
});
export { nav_about as "nav.about" }